import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserPrivileges } from '../../../data/users-mock-data';
import { AccountService } from '../../../services/account.service';
import { UsersService } from '../../../services/users.service';
import { PageGrid } from '../../../utils/page-grid';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
})
export class CustomersComponent implements OnInit {
  active: boolean;
  resultsPageGrid: PageGrid;
  brnPageGrid: PageGrid;
  filterForm: FormGroup;

  gridInProgress;
  currentUser: any;
  isDocumentOfficer: boolean;
  isAdmin: boolean;
  adminOptions: boolean;
  seniorDocOfficer: boolean;
  setUserAccess: boolean;
  activeTab = 'ind';
  constructor(private usersService: UsersService, private fb: FormBuilder, private accountService: AccountService) {}

  async ngOnInit() {
    this.resultsPageGrid = await this.initGrid('ROLE_CUSTOMER');
    this.brnPageGrid = await this.initGrid('ROLE_CORPORATE_USER');
    this.adminOptions = this.accountService.hasPrivilege(UserPrivileges.ADMIN_OPTIONS) ? true : false;

    this.seniorDocOfficer = this.accountService.hasPrivilege(UserPrivileges.MANAGE_ADMIN_USERS) ? true : false;
    this.setUserAccess = this.accountService.hasPrivilege(UserPrivileges.RESEARCH_PORTAL_FULL_ACCESS) ? true : false;
  }

  async initGrid(role) {
    return new PageGrid(this.fb, 20)
      .setSources(
        async (listQuery) => {
          let count;
          this.gridInProgress = true;
          listQuery.filterValues.searchUsers = listQuery.filterValues.searchUsers.replace(/&/i, '%26');
          try {
            count = await this.usersService.filteredUserListCount(listQuery);
          } catch (error) {
            this.gridInProgress = false;
          }
          return { data: count.count || 0 };
        },
        async (listQuery) => {
          let data = [];
          try {
            this.gridInProgress = true;

            data = await this.usersService.filteredUserList(listQuery);
            data.forEach((user) => {
              if (user.userPrivileges.indexOf('RESEARCH_PORTAL_FULL_ACCESS') >= 0) {
                user.access = 'Full';
              } else if (user.userPrivileges.indexOf('RESEARCH_PORTAL_PARTIAL_ACCESS') >= 0) {
                user.access = 'Partial';
              } else {
                user.access = 'None';
              }
            });
            this.gridInProgress = false;
          } catch (error) {
            this.gridInProgress = false;
          }

          return { data };
        }
      )
      .setFilters({
        searchUsers: '',
        role: role,
      });
  }

  toggleTab(tab) {
    this.activeTab = tab;
  }
}
